/** Resolve /images/... paths from page JSON with optional PUBLIC_URL prefix. */
export function withPublicUrl(path?: string, publicUrlPrefix = process.env.PUBLIC_URL || ""): string | undefined {
  if (!path) return undefined;
  if (path.startsWith("http")) return path;
  return `${publicUrlPrefix}${path}`;
}

export function mapPageSections<T extends { img?: string }>(
  sections: T[],
  publicUrlPrefix = process.env.PUBLIC_URL || ""
): T[] {
  return sections.map((section) => ({
    ...section,
    img: withPublicUrl(section.img, publicUrlPrefix),
  }));
}
